<template>
  <section class="cs-offers" :class="{ desktop: $isDesktop }">
    <pitch-type-offers
      v-for="pitchtype in pitchtypes"
      :key="pitchtype.id"
      :offers="pitchtype.activeOffers"
      class="pitchtype-offers"
    >
      <div class="offer-pitch">
        <pu-category-icons
          :categories="pitchtype.categories"
          class="categories"
        />
        <span class="pitchtype-name">{{ pitchtype.name }}</span>
      </div>
    </pitch-type-offers>
  </section>
</template>

<script lang="ts">
import { PitchType } from '../../../campsite-details/types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class CampsiteOffers extends Vue {
  @Prop({ required: true })
  pitchtypes: PitchType[]
}

export default toNative(CampsiteOffers)
</script>

<style scoped>
.pitchtype-offers {
  border-top: 1px solid var(--colour-table-borders);
  margin-bottom: 1em;
}

.offer-pitch {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 0.5em;
}

.pitchtype-name {
  color: var(--colour-dark-blue);
  font-size: var(--body);
  font-weight: bold;
  margin: 0;
}

.categories.category-icons {
  justify-content: flex-start;
  margin: 0 0.5em 0 0;
  flex-shrink: 0;
}

/* desktop & tablet */
.cs-offers.desktop {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(20em, 1fr));
  column-gap: 3em;
}
</style>
